import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
/** Confirmation names the destructive scope; private messages and files are not affected. */
export function CommonChatClearButton({ clear, disabled, children }) {
    const { i18n } = useTranslation();
    const de = i18n?.language?.startsWith('de');
    const [pending, setPending] = useState(false);
    const [status, setStatus] = useState('');
    const label = de ? 'Gemeinsamen Chat für alle leeren' : 'Clear common chat for everyone';
    const run = async () => {
        if (!window.confirm(de
            ? 'Gemeinsamen Raumchat für alle unwiderruflich leeren? Private/Secret Messages und Archivdateien bleiben erhalten. Ältere Clients müssen aktualisiert werden.'
            : 'Permanently clear the common room chat for everyone? Private/Secret Messages and archive files are kept. Older clients must be updated.'))
            return;
        setPending(true);
        setStatus(de ? 'Signatur und Serverbestätigung werden erwartet…' : 'Waiting for signature and server confirmation…');
        try {
            await clear();
            setStatus(de ? 'Gemeinsamer Chat geleert.' : 'Common chat cleared.');
        }
        catch {
            setStatus(de
                ? 'Leeren nicht bestätigt. Verbindung/Wallet prüfen und erneut versuchen.'
                : 'Clear not confirmed. Check connection/wallet and try again.');
        }
        finally {
            setPending(false);
        }
    };
    return _jsxs(_Fragment, { children: [_jsx("button", { className: "mobile-chat-action-btn chat-action-delete", disabled: disabled || pending, onClick: run, title: label, "aria-label": label, "aria-busy": pending, children: children }), status && _jsx("span", { role: "status", style: { fontSize: 12, maxWidth: 220 }, children: status })] });
}
